import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AppToasterProvider } from './components/ui/toaster';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <AppToasterProvider>
      <App />
    </AppToasterProvider>
  </React.StrictMode>
);
